const SAFE_NAME_PATTERN = /[^\p{L}\p{M}\p{Nd}\s'_\.\-\u200c]/gu;
const GENERIC_PARTICIPANT_LABEL_PATTERN = /^(?:اولین\s+)?شرکت[\s\u200c]*کننده(?:\s+(?:شماره|بلاک))?(?:\s+[\p{Nd}#٬,]+)?$/u;

function normaliseWhitespace(value: string): string {
  return value.replace(/\s+/g, " ").trim();
}

/**
 * Normalises a person name by trimming whitespace, removing disallowed characters
 * and collapsing consecutive spaces. Returns null when nothing usable remains.
 */
export function sanitizePersonName(value: string | null | undefined): string | null {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }
  const filtered = trimmed.replace(SAFE_NAME_PATTERN, "");
  const collapsed = filtered.replace(/\s+/g, " ").trim();
  if (!collapsed) {
    return null;
  }
  return collapsed.slice(0, 64);
}

export function isGenericParticipantLabel(value: string | null | undefined): boolean {
  if (typeof value !== "string") {
    return false;
  }
  const normalised = normaliseWhitespace(value);
  if (!normalised) {
    return true;
  }
  if (GENERIC_PARTICIPANT_LABEL_PATTERN.test(normalised)) {
    return true;
  }
  const sanitized = sanitizePersonName(normalised);
  if (!sanitized) {
    return true;
  }
  return GENERIC_PARTICIPANT_LABEL_PATTERN.test(normaliseWhitespace(sanitized));
}
